const photos = {
    "interview-tech": {
          src: "https://images.pexels.com/photos/11857024/pexels-photo-11857024.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
              alt: "Laptop and headphones on a desk for an online interview",
                },
                  "laptops-for-jobseekers": {
                        src: "https://images.pexels.com/photos/7888648/pexels-photo-7888648.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
                            alt: "Laptop and stationery on a bright home-office desk",
                              },
                                "remote-work": {
                                      src: "https://images.pexels.com/photos/36781594/pexels-photo-36781594.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
                                          alt: "Laptop, monitor and headphones in a practical workspace",
                                },
                                  "home-office": {
                                        src: "https://images.pexels.com/photos/4073705/pexels-photo-4073705.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
                                            alt: "Bright home-office desk with an ergonomic chair",
                                  },
                                    tools: {
                                          src: "https://images.pexels.com/photos/37365432/pexels-photo-37365432.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
                                              alt: "Laptop, headphones and notebook on a tidy workspace",
                                    },
                                  };

                                  export default function ResourceVisual({ slug, kind }) {
                                      const photo = photos[slug || kind] || photos.tools;

                                        return (
                                              <div className="resource-photo" style={{ aspectRatio: "16 / 9", overflow: "hidden", borderRadius: "18px 18px 0 0", background: "#edf2f0" }}>
                                                      <img src={photo.src} alt={photo.alt} loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                                                          </div>
                                        );
                                      }

